export default {
    commentsURL: `${process.env.REACT_APP_EDITION_DATA_URL}/comments.json`,
    comments: {},
    loaded: false
}	